import { colors } from 'Constants/Colors';
import styled from 'styled-components';

export const MainContainer = styled.div`
  margin: auto;
`;
export const HeaderContainer = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
`;

export const HeaderContent = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TitleContainer = styled.div`
  text-align: left;
`;

export const Container = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ContainerOptions = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const titleStyle = {
  fontSize: '1.5rem',
  fontFamily: 'var(--app-font)',
};

export const tooltipStyle = {
  margin: 'auto 1rem auto -.5rem',
  color: 'gray',
  fontSize: '1.2rem',
};

export const buttonStyle = { color: colors.WHITE };

export const disabledButtonStyle = {
  color: colors.GRAY,
  backgroundColor: colors.GRAY_DARK,
};

export const subtitleStyle = {
  fontSize: '1rem',
  fontFamily: 'var(--app-font)',
  color: 'gray',
};

export default {
  MainContainer,
  titleStyle,
  Container,
  ContainerOptions,
  buttonStyle,
  HeaderContainer,
  HeaderContent,
  TitleContainer,
  tooltipStyle,
  disabledButtonStyle,
  subtitleStyle,
};
